function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AdministratorsTemplate = require('./administrators.template');
var AdministratorsUI = /*#__PURE__*/function () {
  function AdministratorsUI(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.admin-administrators';
    _classCallCheck(this, AdministratorsUI);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.admins = null;
    this.permissions = null;
    this.busy = false;
    this.error = '';
    this.notice = '';
    this.draft = '';
  }
  return _createClass(AdministratorsUI, [{
    key: "render",
    value: function render() {
      if (!this.mod.server_info) {
        this.app.browser.replaceElementContentBySelector('<p>Waiting for the server to authenticate this administrator.</p>', this.container);
        return;
      }
      this.load();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.app.browser.replaceElementContentBySelector(AdministratorsTemplate({
        admins: this.admins,
        permissions: this.permissions,
        publicKey: this.mod.publicKey,
        busy: this.busy,
        error: this.error,
        notice: this.notice,
        draft: this.draft
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector(this.container);
      if (!root) return;
      root.querySelector('#admin-administrators-refresh').onclick = function () {
        return _this.load();
      };
      var input = root.querySelector('#admin-administrator-key');
      if (input) input.oninput = function () {
        _this.draft = input.value;
      };
      var form = root.querySelector('#admin-administrator-add-form');
      if (form) form.onsubmit = function (event) {
        event.preventDefault();
        _this.add();
      };
      root.querySelectorAll('[data-admin-action]').forEach(function (button) {
        button.onclick = function () {
          return _this.change(button.dataset.adminAction, button.dataset.key);
        };
      });
    }
  }, {
    key: "applyState",
    value: function applyState(state) {
      var _this$mod$server_info;
      this.admins = state.admins;
      this.permissions = state.permissions;
      if ((_this$mod$server_info = this.mod.server_info) !== null && _this$mod$server_info !== void 0 && _this$mod$server_info.options) {
        this.mod.server_info.options.admin = _toConsumableArray(state.admins);
      }
    }
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.busy) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.busy = true;
              this.error = '';
              this.notice = '';
              this.refresh();
              _context.p = 2;
              _t = this;
              _context.n = 3;
              return this.sendRequest('list-admins');
            case 3:
              _t.applyState.call(_t, _context.v);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t2 = _context.v;
              this.error = _t2.message;
              this.permissions = null;
            case 5:
              _context.p = 5;
              this.busy = false;
              this.refresh();
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var key;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.busy) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              key = this.draft.trim();
              if (this.app.crypto.isPublicKey(key)) {
                _context2.n = 2;
                break;
              }
              this.error = 'Not a valid Saito public key.';
              this.notice = '';
              this.refresh();
              return _context2.a(2);
            case 2:
              _context2.n = 3;
              return this.change('add-admin', key);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function add() {
        return _add.apply(this, arguments);
      }
      return add;
    }()
  }, {
    key: "change",
    value: function () {
      var _change = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(request, key) {
        var message, _t3, _t4, _t5, _t6;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!this.busy) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.busy = true;
              this.error = '';
              this.notice = '';
              this.refresh();
              _context3.p = 2;
              if (!(request !== 'add-admin')) {
                _context3.n = 4;
                break;
              }
              message = request === 'promote-admin' ? "Make ".concat(key, " the primary administrator? You will become a regular administrator and can then be removed.") : key === this.mod.publicKey ? 'Remove yourself as an administrator? You will lose access to this server’s admin functions.' : "Remove administrator ".concat(key, "? They will lose access to this server\u2019s admin functions.");
              _context3.n = 3;
              return sconfirm(message);
            case 3:
              if (_context3.v) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              _t3 = this;
              _context3.n = 5;
              return this.sendRequest(request, key);
            case 5:
              _t3.applyState.call(_t3, _context3.v);
              if (request === 'add-admin') this.draft = '';
              this.notice = !this.permissions.is_admin ? 'You have removed yourself and no longer have administrator access.' : request === 'promote-admin' ? 'Primary status transferred. You are now a regular administrator.' : request === 'add-admin' ? 'Administrator added.' : 'Administrator removed.';
              _context3.n = 10;
              break;
            case 6:
              _context3.p = 6;
              _t4 = _context3.v;
              this.error = _t4.message;
              // Refresh permissions after rejection (for example, another admin removed us).
              _context3.p = 7;
              _t5 = this;
              _context3.n = 8;
              return this.sendRequest('list-admins');
            case 8:
              _t5.applyState.call(_t5, _context3.v);
              _context3.n = 10;
              break;
            case 9:
              _context3.p = 9;
              _t6 = _context3.v;
              this.permissions = null;
            case 10:
              _context3.p = 10;
              this.busy = false;
              this.refresh();
              return _context3.f(10);
            case 11:
              return _context3.a(2);
          }
        }, _callee3, this, [[7, 9], [2, 6, 10, 11]]);
      }));
      function change(_x, _x2) {
        return _change.apply(this, arguments);
      }
      return change;
    }()
  }, {
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(request, key) {
        var _this2 = this;
        var tx;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 1:
              tx = _context4.v;
              tx.msg = _objectSpread({
                module: 'Admin',
                request: request
              }, key ? {
                key: key
              } : {});
              _context4.n = 2;
              return tx.sign();
            case 2:
              return _context4.a(2, new Promise(function (resolve, reject) {
                var timer = setTimeout(function () {
                  return reject(new Error('The server did not respond. Refresh to check the current administrator list.'));
                }, 15000);
                try {
                  _this2.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                    clearTimeout(timer);
                    try {
                      var _res$result;
                      var res = res_tx.returnMessage();
                      if (res !== null && res !== void 0 && res.err) throw new Error(res.err);
                      if (!Array.isArray(res === null || res === void 0 || (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.admins) || !res.result.permissions) {
                        throw new Error('The server returned an invalid administrator list.');
                      }
                      resolve(res.result);
                    } catch (err) {
                      reject(err);
                    }
                  }, _this2.mod.server_publickey);
                } catch (err) {
                  clearTimeout(timer);
                  reject(err);
                }
              }));
          }
        }, _callee4, this);
      }));
      function sendRequest(_x3, _x4) {
        return _sendRequest.apply(this, arguments);
      }
      return sendRequest;
    }()
  }]);
}();
module.exports = AdministratorsUI;